import React, {useCallback} from 'react';

import { useDispatch } from 'react-redux';

import { setFilter } from '../reducers/mapDataSlice';

const BuildMarkupForItemitem = React.memo(({ value, checked }) => {
    const dispatch = useDispatch();

    const handler = useCallback((value) => {
        dispatch(setFilter(value));
    }, [])

    return (
        <label key={value} className="checkbox-list-item">
            <input className="checkbox-list-item-input" type="checkbox" checked={checked} onChange={() => handler(value)} />
            <div className={"checkbox-list-item-input-img" + (checked ? ' checkbox-list-item-checked' : '')} />
            <div className='checkbox-list-item-icon' id={value.split(' ').join('-')} />
            <span className="checkbox-list-item-input-label">{value}</span>
            <div className="checkbox-list-item-input-legend" />
        </label>
    );
});

const buildFilterMarkup = (items, filter) => {
    const allSelected = filter.length === items.length;
    return (
        <div className="checkbox-list">
            { <BuildMarkupForItemitem value={'Select All Data'} checked={allSelected} /> }
            { items.map((item) => <BuildMarkupForItemitem key={item.value} value={item.value} checked={filter.includes(item.value)} />) }
        </div>
    );
}

export { buildFilterMarkup };